module.exports = __webpack_public_path__ + "static/img/fjh.3aa6af74.png";